"use client";

import dynamic from "next/dynamic";
import { useMemo } from "react";
import MaxWidthWrapper from "components/Tiles/commonComponents/MaxWidthWrapper";
import { CALENDELY_SCHEDULER_LOCALSTORAGE_KEY } from "components/Tiles/constants";
import "./style.css";
const InlineWidget = dynamic(() => import("react-calendly").then((res) => res.InlineWidget), { ssr: false });
const CalendlyScheduler = ({
  calendarUrl,
  hideEventTypeDetails,
  hideLandingPageDetails,
  inEditor,
  bgColor,
  titleTag = "h1",
  title,
  subTitle,
  textColor
}: {
  calendarUrl: string;
  hideLandingPageDetails?: boolean;
  hideEventTypeDetails?: boolean;
  inEditor?: boolean;
  bgColor?: string;
  titleTag: React.ElementType;
  subTitle?: string;
  title?: string;
  textColor?: string;
}) => {
  const TitleTag = titleTag;

  const prefillValues = useMemo(() => {
    if (typeof window !== "undefined") {
      const savedValues = localStorage.getItem(CALENDELY_SCHEDULER_LOCALSTORAGE_KEY);
      if (savedValues) {
        // remove value after reading
        localStorage.removeItem(CALENDELY_SCHEDULER_LOCALSTORAGE_KEY);
        return JSON.parse(savedValues);
      }
    }
    return {};
  }, []);

  if (!calendarUrl) {
    if (inEditor) {
      return <p className="text-center font-medium">Add calendly url prop value to render this component.</p>;
    } else {
      return null;
    }
  }

  return (
    <section id="CalendlyScheduler-136" style={{ backgroundColor: bgColor }}>
      <MaxWidthWrapper className="relative w-full py-8 lg:py-12">
        <div className="tile-title-container">
          {!!title && (
            <TitleTag className="tile-main-header" style={{ color: textColor }}>
              {title}
            </TitleTag>
          )}
          {!!subTitle && (
            <p className="tile-subtitle" style={{ color: textColor }}>
              {subTitle}
            </p>
          )}
        </div>
        <InlineWidget
          url={calendarUrl}
          pageSettings={{
            hideEventTypeDetails,
            hideLandingPageDetails
          }}
          prefill={prefillValues}
        />
      </MaxWidthWrapper>
    </section>
  );
};

export default CalendlyScheduler;
